var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scroll-bar-wrap", class: { active: _vm.isDisplaySidebar } },
    [
      !_vm.$isTab
        ? _c(
            "div",
            {
              staticClass: "sidebar scroll-box",
              class: { active: _vm.isDisplaySidebar },
            },
            [
              _c("div", { staticClass: "sidebar-header" }, [
                _vm.$userInformation.company &&
                _vm.$userInformation.company.linkIcon
                  ? _c("img", {
                      staticClass: "navbar-img",
                      attrs: {
                        src: _vm.$userInformation.company.linkIcon,
                        alt: _vm.companyName,
                      },
                    })
                  : _c("img", {
                      staticClass: "navbar-img d-none d-lg-block",
                      attrs: {
                        src: require("@/assets/images/logo.png"),
                        alt: _vm.companyName,
                      },
                    }),
              ]),
              _c(
                "ul",
                { staticClass: "list-unstyled components" },
                _vm._l(_vm.routeList, function (route1) {
                  return _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasPermission(
                            route1.name,
                            route1.permission
                          ),
                          expression:
                            "hasPermission(route1.name, route1.permission)",
                        },
                      ],
                      key: route1.name,
                      class: {
                        active:
                          _vm.$route.name === route1.name && !route1.isParent,
                      },
                    },
                    [
                      route1.isParent && route1.children.length >= 1
                        ? _c("div", { staticClass: "sidebar-list-container" }, [
                            _c(
                              "div",
                              {
                                staticClass: "sidebar-parent",
                                on: {
                                  click: function ($event) {
                                    return _vm.showChildren(route1.name)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "sidebar-name" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("navigation." + route1.name))
                                  ),
                                ]),
                                _c("font-awesome-icon", {
                                  staticClass: "float-right caret",
                                  class: { open: !route1.hideChildren },
                                  attrs: { icon: "caret-down" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "ul",
                              {
                                staticClass: "sidebar-child",
                                class: { "hide-me": route1.hideChildren },
                              },
                              _vm._l(route1.children, function (route2) {
                                return _c(
                                  "li",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.hasPermission(
                                          route2.name,
                                          route2.permission
                                        ),
                                        expression:
                                          "hasPermission(route2.name, route2.permission)",
                                      },
                                    ],
                                    key: route2.name,
                                    class: {
                                      active: _vm.$route.name === route2.name,
                                    },
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        key: route2.name,
                                        attrs: { to: route2.route },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("navigation." + route2.name)
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ])
                        : _c(
                            "router-link",
                            { key: route1.name, attrs: { to: route1.route } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("navigation." + route1.name))
                              ),
                            ]
                          ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "v-cover-bar" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }